import domReady from '@roots/sage/client/dom-ready';
import "@lottiefiles/lottie-player";
import {header} from "@scripts/modules/header.js";
import {mobilemenu} from "@scripts/modules/menu.js";
import {intro} from "@scripts/modules/intro.js";
import {accordion} from "@scripts/modules/accordion.js";
import {slider} from "@scripts/modules/slider.js";
import {scrollDown} from "@scripts/modules/scrollDown.js";
import {musicHero, songsSingleProduct} from "@scripts/modules/music.js";
import {musicContentProduct} from "@scripts/modules/music.js";
import {singleProductSample} from "@scripts/modules/music.js";

import {scrollAnimations} from "@scripts/modules/scrollAnimations.js";
import {bubbles} from "@scripts/modules/bubbles.js";
import {storeNotice} from "@scripts/modules/storeNotice.js";

/**
 * Application entrypoint
 */
domReady(async() => {
  // ...

    let popupShown = localStorage.getItem('popupShown');

    let pageLoadType = performance.navigation.type;

    if (!popupShown || pageLoadType === performance.navigation.TYPE_RELOAD) {
        intro();
        localStorage.setItem('popupShown', 'true');
    }

    header()
    mobilemenu()
    accordion()
    slider()
    scrollDown()
    bubbles()
    musicHero()
    scrollAnimations()
    musicContentProduct()
    singleProductSample()
    storeNotice()



});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) {
    import.meta.webpackHot.accept(console.error);
}
